// Session storage keys
export const SAVED_FORM = 'savedForm';
export const FORM_CATEGORY = 'formCategory';
